<template>
  <div class="authentication">
    <div class="authentication_wrap">
      <div class="one">
        <EssentialInformation :userInfo="userInfo" @succe="succe" />
      </div>
      <el-divider></el-divider>
      <div class="two">
        <LanguageAbility :userInfo="userInfo" @succe="succe" />
      </div>
      <el-divider></el-divider>
      <div class="three">
        <WorkExperience :userInfo="userInfo" @succe="succe" />
      </div>
      <el-divider></el-divider>
      <div class="four">
        <Education :userInfo="userInfo" @succe="succe" />
      </div>
      <el-divider></el-divider>
      <div class="five">
        <TranslationCases :userInfo="userInfo" @succe="succe" />
      </div>
      <el-divider></el-divider>
      <div class="six">
        <SelfEvaluation :userInfo="userInfo" @succe="succe" />
      </div>
      <el-divider></el-divider>
      <div class="seven">
        <Certificate :userInfo="userInfo" @succe="succe" />
      </div>
      <el-divider></el-divider>
      <div class="eight">
        <ProvidingServices :userInfo="userInfo" @succe="succe" />
      </div>
      <div v-if="userInfo.auditStatus !==1" class="subBtn" @click="goAuthentication">{{subBtn}}</div>
      <div v-if="userInfo.auditStatus ===1" class="subBtn1" @click="goAuthentication"><i></i>认证通过</div>
    </div>
  </div>
</template>

<script>
import EssentialInformation from '../../common/MemberCertification/EssentialInformation.vue' // 基本信息
import LanguageAbility from '../../common/MemberCertification/LanguageAbility.vue' // 语言能力
import WorkExperience from '../../common/MemberCertification/WorkExperience.vue' // 工作经验
import Education from '../../common/MemberCertification/Education.vue' // 工作经验
import TranslationCases from '../../common/MemberCertification/TranslationCases.vue' // 翻译案例
import SelfEvaluation from '../../common/MemberCertification/SelfEvaluation.vue' //自我评价
import Certificate from '../../common/MemberCertification/Certificate.vue' //f翻译证书
import ProvidingServices from '../../common/MemberCertification/ProvidingServices.vue' //提供服务

//Language ability
export default {
  components: {
    EssentialInformation,
    LanguageAbility,
    WorkExperience,
    Education,
    TranslationCases,
    SelfEvaluation,
    Certificate,
    ProvidingServices
  },
  data () {
    return {
      userInfo: {},//译员认证对象
      subBtn: "",
      myUser: {},
      // arr:[],// 判断是否村
    };
  },
  async created () {

    this.myUser = JSON.parse(localStorage.getItem("myUser"))
    await this.registerInfo(this.myUser.id)
  },
  methods: {
    // 拉取认证
    async registerInfo (userId) {
      let url = "/v1/userRegister/get_new_user_register_info"
      let params = {
        userId
      }
      try {
        const { resultCode, result } = await this.catReq1Service(url, params, "get")
        if (resultCode === "1") {
          if (result.workList !== null) {
            // 转换工作日期
            if (result.workList.length !== 0) {
              let workArr = [...result.workList]
              workArr.forEach(item => {
                item.work_time = []
                item.work_time.push(item.workStartTime)
                item.work_time.push(item.workEndTime)
                delete item.workStartTime
                delete item.workEndTime
              });
              result.work_experience = workArr
            }
            // 转换就读日期
            if (result.studyList !== null) {
              if (result.studyList.length !== 0) {
                let studyList = [...result.studyList]
                studyList.forEach(item => {
                  item.school_time = []
                  item.school_time.push(item.studyStartTime)
                  item.school_time.push(item.studyEndTime)
                  delete item.studyStartTime
                  delete item.studyEndTime
                });
                result.education = studyList
              }

            }

          }
          this.userInfo = result
          this.userInfo.num = 1
          //
          if (result.auditStatus === null || result.auditStatus === 2) {
            this.subBtn = "提交认证"
          } else if (result.auditStatus === 0) {
            this.subBtn = "审核中"
          } else if (result.auditStatus === 1) {
            this.subBtn = "认证完成"
          }
        }

      } catch (error) {

      }
    },
    succe (value) {
      value.num = 1
      if (value.auditStatus === 0) {
        this.$message({
          message: "您修改的认证内容已经更新并提交~",
          type: "success"
        });
        //
      }
      if (value.workList !== null) {
        if (value.workList.length !== 0) {
          let workArr = [...value.workList]
          workArr.forEach(item => {
            item.work_time = []
            item.work_time.push(item.workStartTime)
            item.work_time.push(item.workEndTime)
            delete item.workStartTime
            delete item.workEndTime
          });
          value.work_experience = workArr
        }

      }
      if (value.studyList !== null) {
        if (value.studyList.length !== 0) {
          let studyList = [...value.studyList]
          studyList.forEach(item => {
            item.school_time = []
            item.school_time.push(item.studyStartTime)
            item.school_time.push(item.studyEndTime)
            delete item.studyStartTime
            delete item.studyEndTime
          });
          value.education = studyList
        }

      }

      this.userInfo = value
      console.log(this.userInfo, "-----------------")
    },
    // 认证
    async goAuthentication () {
      let that = this
      if (this.userInfo.auditStatus === 0) {
        this.$message.closeAll();
        that.$message({
          message: "您修改的认证内容已经更新并提交~",
          type: "warning"
        });
        return
      }
      if (this.userInfo.auditStatus === 1) {
        this.$message.closeAll();
        that.$message({
          message: "认证通过不可修改",
          type: "warning"
        });
        return
      }
      if (!this.userInfo) {
        this.$message.closeAll();
        that.$message({
          message: "信息不完整暂不能认证",
          type: "warning"
        });
        return
      }
      let isEmpty = false;
      let _this = this
      // //function (x) {
      //   if (object[x] != null && object[x] != "") {
      //     isEmpty = false;
      //   }
      // }
      delete _this.userInfo.certificateUrls  //  非必填选项
      delete _this.userInfo.tranCase  //  非必填选项
      delete _this.userInfo.selfReview  //  非必填选项
      Object.keys(_this.userInfo).forEach(e => {
        if (_this.userInfo[e] == null || _this.userInfo[e] === '' || _this.userInfo[e].length < 1) {
          isEmpty = true;
        }
      });
      if (isEmpty) {//值全为空
        _this.$message({
          message: "信息不完整暂不能认证",
          type: "warning"
        });
        return
      }
      let url = "/v1/userRegister/add_or_update_register_info"
      let params = {
        id: _this.userInfo.id,
        userId: _this.userInfo.userId,
        auditStatus: 0,
        certificateUrls: _this.userInfo.certificateUrls
      }
      const res = await this.catReq1Service(url, params)
      if (res.resultCode === "1") {
        _this.$message({
          message: "已提交审核",
          type: "warning"
        });

        this.subBtn = "审核中"
        this.reload()
        return
      }
    },
  },
};
</script>

<style lang="less" scoped>
.authentication_wrap {
  width: 77%;
  margin: 0 auto;
  text-align: left;
  .subBtn {
    width: 100px;
    height: 36px;
    text-align: center;
    background: rgba(30, 134, 230, 1);
    box-shadow: 0px 3px 8px 0px rgba(30, 134, 230, 0.5);
    border-radius: 4px;
    font-size: 16px;
    line-height: 36px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }

  .subBtn1 {
    width: 100px;
    height: 36px;
    text-align: center;
    background: #37bd6d;
    box-shadow: 0px 1px 1px 0px rgba(55, 189, 109, 0.3);
    border-radius: 4px;
    font-size: 16px;
    line-height: 36px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    i {
      width: 23px;
      height: 23px;
      display: inline-block;
      vertical-align: middle;
      background: url("../../assets/imgs/authentication/affirm_clickable_icon.png")
        no-repeat;
      background-size: cover;
    }
  }
}
</style>
